module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-5-zoom.010b19e7.png";